/**
 * Setup the sticky sidebar the Data Attributes for the bootstrap affix feature,
 * offsets the top to window in the elements original position.
 * For this function to work the selector element needs to
 * have a data-spy="affix" attribute added.
 *
 * @see: http://getbootstrap.com/javascript/#affix
 *
 * @param  {string} selector the sidebar element to target
 */
export function setupFixedSidebar(selector) {
  const elem = document.querySelector(selector);

  if (! elem) {
    return;
  }

  let promoHeight = 0;

  const siteHeader = document.querySelector('.header-site');
  const chlPromo = document.querySelector('.chcf-promo');
  const khnPromo = document.querySelector('.promo-homepage');
  const siteFooter = document.querySelector('.footer-site');

  // add top offset data attribute
  elem.setAttribute(
    'data-offset-top',
    (window.pageYOffset + (elem.getBoundingClientRect().top)) - 40
  );

  // if page is reloaded while scrolled down the page add a not-top class
  if (! siteHeader.classList.contains('scrolling')) {
    elem.classList.add('not-top');
  }

  // class used for CHL
  if (chlPromo) {
    promoHeight = chlPromo.offsetHeight + 45;
  }

  // class used for KHN
  if (khnPromo) {
    promoHeight = khnPromo.offsetHeight;
  }

  if (siteFooter) {
    elem.setAttribute(
      'data-offset-bottom',
      (siteFooter.offsetHeight + promoHeight)
    );
  }
}

/**
 * Sticky function for adding a sticky class with an offset
 *
 * @param  {string} selector  the selector to target
 * @param  {string} className the class name to toggle
 * @param  {int}    offset    the offset from the top
 */
export function addStickyClass(selector, className, offset) {
  const elem = document.querySelector(selector);

  if (! elem) {
    return;
  }

  if (window.pageYOffset >= offset) {
    elem.classList.add(className);
  } else {
    elem.classList.remove(className);
  }
}

export default {
  setupFixedSidebar,
  addStickyClass,
};
